<template>
  <div class="main-container d-flex">
    <div
      class="image-container"
      :class="isOverlay ? 'image-container-overlay' : 'image-container-none-overlay'"
      :style="!alignRight ? opacityStyle : 'opacity: 0.5'"
    >
      <img
        :src="require(`@/assets/${imageSrc}`)"
        alt="Banner Image"
        class="main-img"
      >
    </div>
    <div
      class="heading-container"
      :class="[isOverlay ? 'heading-container-shadow' : 'heading-container', alignRight ? 'title-right' : '']"
    >
      <div
        :style="{color: bannerHeadingColor}"
        :class="isHeadingRight ? 'heading-main-is-right' : 'heading-container-main'"
      >
        {{ heading }}
      </div>
      <div class="heading-container-sub" :style="{color: bannerHeadingColor}">
        {{ subheading }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, computed, ref, Ref } from 'vue';

  const props = defineProps<{
    imageSrc: string;
    heading: string;
    subheading: string;
    bannerHeadingColor: string;
    isOverlay: boolean,
    isHeadingRight: boolean,
    isLowOpacity: boolean,
    alignRight: boolean
  }>();

  const opacityStyle = computed(() => {
    return props.isLowOpacity ? { opacity: '0.65' } : {};
  });
</script>

<style scoped>
.main-container {
  position: relative;
  z-index: 20;
  /* margin-top: -64px; */
  align-items: center;
}
.main-img {
  display: block;
  width: 100%;
}
.image-container {
  position: relative;
  width: 100%;
}
.image-container img {
  display: block;
  width: 100%;
  height: 315px;
  object-fit: cover;
}
.image-container-overlay::before{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(150deg, #000000db, transparent);
}
.image-container-none-overlay::before{
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.heading-container{
  position: absolute;
  color: white;
  font-size: 52px;
  z-index: 3;
  width: calc(100% - 100px);
  font-weight: 600;
  margin-left: 100px;
  /* margin-left: 148px; */
  /* text-shadow: 1px 3px 5px rgba(0, 0, 0, 0.4); */
}
.heading-container-shadow{
  text-shadow: 1px 3px 5px rgba(0, 0, 0, 0.4);
}
.heading-container-main{
  font-size: 40px;
}
.heading-container-sub{
  font-size: 24px;
}
.heading-main-is-right{
  font-size: 64px;
  float: right;
  margin-right: 14vw;
  font-weight: 500;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 3px;
}
.title-right{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 0px;
  text-shadow: none !important;
}
@media (max-width: 1200px) {
  .image-container img {
    height: 280px;
  }
  .heading-main-is-right{
    font-size: 58px;
  }
}
@media (max-width: 1100px) {
  .image-container img {
    height: 260px;
  }
  .heading-main-is-right{
    font-size: 52px;
  }
}
@media (max-width: 1000px) {
  .image-container img {
    height: 240px;
  }
  .heading-main-is-right{
    font-size: 46px;
    letter-spacing: 2px;
  }
}
@media (max-width: 940px) {
  .image-container img {
    height: 220px;
  }
  .heading-container{
    margin-left: 45px;
    /* margin-left: 0px; */
    font-size: 45px;
    display: inline-grid;
    justify-content: center;
  }
  .heading-container div{
    display: flex;
    justify-content: center;
  }
  .heading-container-sub{
    text-align: center;
  }
  .heading-container-main{
    text-align: center;
  }
  .heading-main-is-right{
    text-align: center;
    font-size: 40px;
    margin-right: 0vw;
  }
}
@media (max-width: 800px) {
  .image-container img {
    height: 200px;
  }
  .heading-container-main{
    font-size: 37px;
  }
  .heading-container-sub{
    font-size: 21px;
  }
  .heading-main-is-right{
    font-size: 38px;
  }
}
@media (max-width: 700px) {
  .heading-container{
    font-size: 40px;
  }
  .image-container img {
    height: 180px;
  }
  .heading-container-main{
    font-size: 33px;
  }
  .heading-container-sub{
    font-size: 18px;
  }
  .heading-main-is-right{
    font-size: 35px;
    letter-spacing: 1px;
  }
}
@media (max-width: 615px) {
  .heading-container{
    font-size: 30px;
  }
  .image-container img {
    height: 160px;
  }
  .heading-container-main{
    font-size: 30px;
  }
  .heading-container-sub{
    font-size: 14px;
  }
}
@media (max-width: 570px) {
  .heading-container{
    font-size: 30px;
  }
  .image-container img {
    height: 160px;
  }
  .heading-container-main{
    font-size: 26px;
  }
  .heading-container-sub{
    font-size: 14px;
  }
}
</style>
